import {useGetAccessProfiles} from './useGetAccessProfiles'
import {THERAPIST_ROLE_NAME} from '../utils'

/* Resolves the id of the operative therapists access profile from `GET /roles` by exact name.
`isNotFound` is true when the roles loaded but none matches: callers must not issue an unscoped
users request in that case. */
export const useGetTherapistRole = () => {
    const query = useGetAccessProfiles()
    const role = query.data?.find(role => role.name === THERAPIST_ROLE_NAME)

    return {
        roleId: role?.id,
        isPending: query.isPending,
        isError: query.isError,
        isNotFound: query.isSuccess && !role
    }
}
